import { PillTheme } from "@redotech/redo-storefront-common/pill-theme";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { ConversationTagSource } from "./conversation-tag-source";
import { CustomerTagSource } from "./customer-tag-record";

export enum TagKind {
  FULFILLMENT_GROUP = "fulfillment-group",
  CONVERSATION = "conversation",
  CUSTOMER = "customer",
  RETURN = "return",
  SHIPMENT = "shipment",
  CAMPAIGN = "campaign",
}

export enum FulfillmentGroupTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

export enum ReturnTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
  FLOW = "flow",
}

export enum ShipmentTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

// Campaign tags are not backed by a DB enum; these values merely coincide with shipping_claim_source. //redontIgnore
export enum CampaignTagSource {
  MERCHANT = "merchant",
  REDO = "redo",
}

export const TagKindSchema = createEnum(TagKind, { enumName: "TagKind" });
export const PillThemeSchema = createEnum(PillTheme, { enumName: "PillTheme" });
export const CustomerTagSourceSchema = createEnum(CustomerTagSource, {
  enumName: "CustomerTagSource",
});
export const ConversationTagSourceSchema = createEnum(ConversationTagSource, {
  enumName: "ConversationTagSource",
});
export const FulfillmentGroupTagSourceSchema = createEnum(
  FulfillmentGroupTagSource,
  { enumName: "FulfillmentGroupTagSource" },
);
export const ReturnTagSourceSchema = createEnum(ReturnTagSource, {
  enumName: "ReturnTagSource",
});
export const ShipmentTagSourceSchema = createEnum(ShipmentTagSource, {
  enumName: "ShipmentTagSource",
});
export const CampaignTagSourceSchema = createEnum(CampaignTagSource, {
  enumName: "CampaignTagSource",
});

const TagSchema_ = z.object({
  _id: zExt.objectId().nullish().meta({ privacy: privacy.nonPii }),
  name: z.string().meta({ privacy: privacy.nonPii }),
  numericId: z.number().nullish().meta({ privacy: privacy.nonPii }),
  pillTheme: PillThemeSchema.meta({ privacy: privacy.nonPii }),
  source: z
    .union([
      CustomerTagSourceSchema,
      ConversationTagSourceSchema,
      FulfillmentGroupTagSourceSchema,
      ReturnTagSourceSchema,
      ShipmentTagSourceSchema,
      CampaignTagSourceSchema,
    ])
    .meta({ privacy: privacy.nonPii }),
  kind: TagKindSchema.meta({ privacy: privacy.nonPii }),
});
export const TagSchema: z.ZodType<Tag> = TagSchema_;
export interface Tag extends z.infer<typeof TagSchema_> {}

const TagDocumentSchema_ = TagSchema_.extend({
  team: zExt.objectId().optional().meta({ privacy: privacy.nonPii }),
});
export const TagDocumentSchema: z.ZodType<TagDocument> = TagDocumentSchema_;
export interface TagDocument extends z.infer<typeof TagDocumentSchema_> {}
